<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="reportCode" label="委托编号">
        <el-input
          v-model="searchModel.reportCode"
          placeholder="请输入委托编号"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>
      <el-form-item prop="client" label="委托单位">
        <el-input
          v-model="searchModel.client"
          placeholder="请输入委托单位"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>
      <el-form-item prop="sampleName" label="检测项目">
        <el-input
          v-model="searchModel.sampleName"
          placeholder="请输入检测项目"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>
      <el-form-item v-show="!collapsed" prop="dateRange" label="创建时间">
        <el-date-picker
          v-model="searchModel.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          clearable
          @change="getTableData(true)"
        ></el-date-picker>
      </el-form-item>

      <el-form-item class="form-btn" label-width="0">
        <el-button type="success" @click="getTableData(true)">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
        <el-button type="text" class="search-isOpen" @click="collapsed = !collapsed">
          {{ collapsed ? '展开' : '收起' }}
          <i class="el-icon--right" :class="collapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
        </el-button>
      </el-form-item>
    </el-form>

    <div class="cbox-p14 table-main">
      <TableHeader :refTable="refTable" @onRefresh="getTableData()">
        <el-button :loading="exportLoading" type="primary" @click="handleExport">导出</el-button>
      </TableHeader>

      <el-table
        v-loading="tableLoading"
        ref="table"
        :data="tableData"
        :span-method="invoiceSpanMethod"
        border
        stripe
        height="100%"
        :summary-method="getSummaries"
        show-summary
      >
        <el-table-column prop="reportCode" label="报告编号" width="160" align="center"></el-table-column>
        <el-table-column prop="state" label="报告状态" width="120" align="center">
          <template v-slot="{ row }">
            {{ row.state | stateFilter }}
          </template>
        </el-table-column>
        <el-table-column prop="client" label="委托单位" align="center"></el-table-column>
        <el-table-column prop="testItemText" label="检测项目" align="center"></el-table-column>
        <el-table-column prop="model" label="数量" align="center">
          <template v-slot="{ row }">{{ row.totalCnt }}</template>
        </el-table-column>
        <el-table-column prop="unitPrice" label="收费单价（元）" min-width="120" align="center"></el-table-column>
        <el-table-column prop="totalPrice" label="收费小计（元）" min-width="120" align="center"></el-table-column>

        <el-table-column label="操作" width="140" align="center">
          <template v-slot="{ row }">
            <div class="link-wrap">
              <div>
                <el-link type="primary" @click="handleEdit(row)">编辑</el-link>
                <el-link type="primary" @click="handleInvoiceNo(row)">修改发票号</el-link>
              </div>
              <el-link type="primary" @click="handleDownloadOrder(row)">下载收费单据</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev, sizes ,pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <!-- 编辑单价 弹窗 -->
    <InvoiceEdit :visible.sync="editVisible" :activeRowId="activeRowId" @refresh="getTableData()" />
    <!-- 发票号 弹窗 -->
    <InvoiceNoEdit :visible.sync="batchNoVisible" :activeRows="activeRows" @refresh="getTableData()" />
  </div>
</template>

<script>
import TableHeader from '@/components/TableHeader';
import InvoiceEdit from '../components/InvoiceEdit';
import InvoiceNoEdit from '../components/InvoiceNoEdit';

import { getReportInvoiceCodeList, exportReportInvoiceCodeInfo, exportReportInvoiceCodeList } from '@/api/invoice';

export default {
  components: { TableHeader, InvoiceEdit, InvoiceNoEdit },
  data() {
    return {
      collapsed: true,
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        invoiceState: 1,
        client: '',
        reportCode: '',
        sampleName: '',
        dateRange: []
      },
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      tableSelection: [],
      // 弹窗
      activeRowId: null,
      editVisible: false,
      activeRows: [],
      batchNoVisible: false,
      exportLoading: false
    };
  },
  filters: {
    stateFilter(state) {
      switch (state) {
        case 2:
        case 3:
          return '任务待分配';
        case -8:
        case -9:
        case 4:
        case 6:
          return '编制中';
        case 7:
          return '审核中';
        case 8:
          return '批准中';
        case 9:
          return '已完成';
      }
    }
  },
  computed: {},
  watch: {},
  methods: {
    // 合并单元格
    invoiceSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 5 || columnIndex == 10) {
        if (rowIndex === 0) {
          return {
            rowspan: this.getSpanCount(rowIndex, columnIndex),
            colspan: 1
          };
        } else {
          if (this.tableData[rowIndex].reportCode === this.tableData[rowIndex - 1].reportCode) {
            return {
              rowspan: 0,
              colspan: 0
            };
          } else {
            return {
              rowspan: this.getSpanCount(rowIndex, columnIndex),
              colspan: 1
            };
          }
        }
      }
    },
    getSpanCount(rowIndex, columnIndex) {
      let count = 1;
      for (let i = rowIndex + 1; i < this.tableData.length; i++) {
        if (this.tableData[i].reportCode === this.tableData[rowIndex].reportCode) {
          count++;
        } else {
          break;
        }
      }
      return count;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 8) {
          sums[index] = '合计';
          return;
        }
        if (index == 9) {
          const values = data.map(item => Number(item[column.property]));
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += ' 元';
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getTableData();
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const startDate = this.searchModel?.dateRange?.[0] ?? null;
      const endDate = this.searchModel?.dateRange?.[1] ?? null;
      const startTime = startDate ? startDate + ' 00:00:00' : null;
      const endTime = endDate ? endDate + ' 23:59:59' : null;

      const { data } = await getReportInvoiceCodeList({ ...this.searchModel, startTime, endTime });
      this.dataTotal = data.count;
      const tableData = data.list || [];

      const mutiTableData = [];
      tableData.forEach(item => {
        item.infoList.forEach(sample => {
          mutiTableData.push({
            ...item,
            sampleName: sample.sampleName,
            model: sample.model,
            totalCnt: sample.totalCnt,
            testItemText: sample.testItemText,
            unit: sample.unit,
            unitPrice: sample.unitPrice,
            totalPrice: sample.totalPrice
          });
        });
      });
      this.tableData = mutiTableData;

      this.tableLoading = false;

      this.$nextTick(() => {
        this.$refs.table.doLayout(); // 重置表格布局
      });
    },
    handleEdit(row) {
      this.activeRowId = row.id;
      this.editVisible = true;
    },
    handleInvoiceNo(row) {
      this.activeRows = [{ reportCode: row.reportCode, id: row.id }];
      this.batchNoVisible = true;
    },
    async handleDownloadOrder(row) {
      return this.$message.warning('开发中');
      const res = await exportReportInvoiceCodeInfo({
        id: row.id
      });
      // 解析文件名
      let filename = '收费单据.xlsx';
      const contentDisposition = res.headers['content-disposition'];
      if (contentDisposition) {
        const matches = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (matches && matches[1]) {
          filename = matches[1].replace(/['"]/g, '');
          filename = decodeURIComponent(filename);
        }
      }

      // 创建 Blob URL 并触发下载
      const blob = new Blob([res.data], { type: 'application/octet-stream' }); // 显式指定类型
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(link.href);
    },
    async handleExport() {
      return this.$message.warning('开发中');
      const startDate = this.searchModel?.dateRange?.[0] ?? '';
      const endDate = this.searchModel?.dateRange?.[1] ?? '';
      const startTime = startDate ? startDate + ' 00:00:00' : '';
      const endTime = endDate ? endDate + ' 23:59:59' : '';
      const { client, reportCode, sampleName } = this.searchModel;

      this.exportLoading = true;

      try {
        const res = await exportReportInvoiceCodeList({
          startTime,
          endTime,
          client,
          reportCode,
          sampleName,
          invoiceState: 1
        });
        // 解析文件名
        let filename = '已开票发票信息.xlsx';
        const contentDisposition = res.headers['content-disposition'];
        if (contentDisposition) {
          const matches = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (matches && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
            filename = decodeURIComponent(filename);
          }
        }
        // 创建 Blob URL 并触发下载
        const blob = new Blob([res.data], { type: 'application/octet-stream' }); // 显式指定类型
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(link.href);
      } finally {
        this.exportLoading = false;
      }
    }
  },
  mounted() {
    this.refTable = this.$refs.table;
  },
  activated() {
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  } //页面有keep-alive触发
};
</script>

<style lang="scss" scoped>
.link-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
</style>
